var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg005SgRfpsMiniBids = function Svg005SgRfpsMiniBids(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M392 412h-60c-22.091 0-40 17.909-40 40v40h60v-40c0-22.091 17.909-40 40-40z",
    fill: "#14d64d",
    "data-original": "#cee1f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292 492v-40c0-22.091 17.909-40 40-40h80c22.091 0 40 17.909 40 40v40m40 0H252",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452 332h40m-63.431-56.569 28.284-28.284",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#ff5cf4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.147 274.558c-15.621 15.621-40.948 15.621-56.569 0L165.442 161.421c-15.621-15.621-15.621-40.948 0-56.569m28.284-28.283c15.621-15.621 40.948-15.621 56.569 0l113.137 113.137c15.621 15.621 15.621 40.948 0 56.569m-84.853 84.852L420 189.706m-311.127-28.285L250.294 20M20 420l202.01-202.01",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }));
};

export default Svg005SgRfpsMiniBids;